<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/connections/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Connection</h1>
          <div class="row">
            <div class="col-xs-6">
              <inputbox id="name" label="Megnevezés" v-bind:errors="errors" name="name" v-model="form.name"></inputbox>
              <comboboxV2 id="gateway_id" label="Gateway" v-bind:errors="errors" name="gateway_id" v-model="form.gateway_id" :options="gateways"></comboboxV2>
              <inputbox id="rs232_port_dev_name" label="RS232 Port név" v-bind:errors="errors" name="rs232_port_dev_name" v-model="form.rs232_port_dev_name"></inputbox>
              <inputbox regexp_filter="[0-9]+" id="rs232_baud_rate" label="RS232 Baud Rate" v-bind:errors="errors" name="rs232_baud_rate" v-model="form.rs232_baud_rate"></inputbox>
              <inputbox regexp_filter="[0-9.]+" id="ip" label="IP" v-bind:errors="errors" name="ip" v-model="form.ip"></inputbox>
              <inputbox regexp_filter="[0-9.]+" id="port" label="Port" v-bind:errors="errors" name="port" v-model="form.port"></inputbox>
              <textareabox id="comment" label="Megjegyzés" v-bind:errors="errors" name="comment" v-model="form.comment"></textareabox>
            </div>
          </div>
        </div>
      </div>

    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      form: {
        element_id: 0,
        name: '',
        gateway_id: 0,
        rs232_port_dev_name: '',
        rs232_baud_rate: '',
        ip: '',
        comment: '',
        port: ''
      },
      gateways: [{
        label: '- összes -',
        value: 0
      }],
      errors: [],
      is_save: false
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('connection/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.connectionID != undefined ? _this.$route.query.connectionID : 0), {
        success: function(response) {
          _this.form = response.connection;
          _this.getGateWays();
        }
      });
    });
  },

  methods: {
    getGateWays: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('gateways/' + _this.$root.user.apikey + '/1', {
          method: 'POST',
          data: {},
          success: function(response) {
            response.gateways.map(function(gateway) {
              _this.gateways.push({
                label: gateway.name,
                value: gateway.element_id
              })
            });
          }
        });
      });
    },

    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('connection/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              _this.$router.push({path: '/connections'});
            }
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// connection.vue?96a1bc5e